import React from "react";
import CompletedDataComponent from "./CompletedDataComponent";
import MyLoader from "../HOC/MyLoader";
const CompletedComponent = props => {
  return (
    <div className="maincontent container">
      <CompletedDataComponent jobsobject={props.jobs} />
    </div>
  );
};
export default MyLoader(CompletedComponent, "delivered");



// WEBPACK FOOTER //
// ./src/components/Completed/CompletedComponent.js